import { actions } from './slices';
import {
  setAutoplayAsync,
  setNextTitleAsync,
  getAuthProvidersAsync,
  linkAppleAsync,
  linkFacebookAsync,
  linkGoogleAsync,
  linkGoogleAccessTokenAsync,
  linkTwitterAsync,
  setPasswordByInvitationTokenAsync,
  registerToBusinessGroupAsync,
  getUserCountryAsync,
} from './thunks';

export const AccountActions = {
  ...actions,
  setAutoplayAsync,
  setNextTitleAsync,
  getAuthProvidersAsync,
  linkAppleAsync,
  linkFacebookAsync,
  linkGoogleAsync,
  linkGoogleAccessTokenAsync,
  linkTwitterAsync,
  setPasswordByInvitationTokenAsync,
  registerToBusinessGroupAsync,
  getUserCountryAsync,
};

export * from './thunkHandlers';
